module.exports = __webpack_public_path__ + "static/media/fire-theft-icon@2x.2abe0b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/fire-theft-icon@2x.png
// module id = 1255
// module chunks = 0